export default "__VITE_ASSET__WdWFJciA__"